export const handlePopupDisappear = (e, fields) => {
    if (
        e.api.getEditingCells().filter((c) => fields.includes(c.column.colId))
            .length > 0
    ) {
        e.api.stopEditing();
    }
};

export const handlePopupReposition = () => {
    const xPosition = window.scrollX || window.pageXOffset;
    const yPosition = window.scrollY || window.pageYOffset;
    if (xPosition > 0 || yPosition > 0) {
        // if body scroll moves, change popup position
        let el = document.getElementsByClassName("react-datepicker__tab-loop");
        if (!el[0]) {
            el = document.getElementsByClassName("ag-rich-select");
        }
        if (el[0]) {
            el[0].setAttribute(
                "style",
                `margin-left:${-1 * xPosition}px;margin-top:${
                    -1 * yPosition
                }px;`
            );
        }
    }
};

export const resetBodyScroll = (scrollable) => {
    if (scrollable) {
        document.body.style.overflow = "visible";
    } else {
        // set scroll to left
        window.scrollTo(0, 0);
        document.body.style.overflow = "hidden";
    }
};
